import SectionHeading from "@/pages/home/components/SectionHeading";
import { devices } from "@/mocks/home";

const toneStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function DeviceSection() {
  return (
    <section
      id="device-support"
      className="scroll-mt-28 py-14 md:py-20 bg-background-100 border-y border-background-200"
    >
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="设备支持"
          title="手机、电脑、电视都能看"
          desc="不同设备的打开方式不太一样，下面按设备整理了对应的访问建议。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {devices.map((device) => {
            const tone = toneStyles[device.tone] ?? toneStyles.primary;
            return (
              <div
                key={device.id}
                className="flex flex-col p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <span className={`w-11 h-11 rounded-md flex items-center justify-center ${tone}`}>
                  <i className={`${device.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">
                  {device.name}
                </h3>
                <span className="mt-2 self-start text-xs font-medium text-secondary-800 bg-secondary-100/80 rounded-full px-2.5 py-1">
                  {device.support}
                </span>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{device.detail}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-5 rounded-lg bg-background-50 border border-background-200">
            <h3 className="font-heading font-bold text-sm text-foreground-950">推荐浏览器</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              Chrome、Edge、Safari 等主流浏览器的最新版本均可正常访问，建议开启 JavaScript。
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-50 border border-background-200">
            <h3 className="font-heading font-bold text-sm text-foreground-950">网络建议</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              稳定的 Wi-Fi 或 4G/5G 网络能获得更流畅的播放效果，避免同时进行大流量下载。
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-50 border border-background-200">
            <h3 className="font-heading font-bold text-sm text-foreground-950">存储空间</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              安装客户端前请预留一定存储空间，保证系统盘与缓存目录有足够容量。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}